<template>
  <div class="donation-invite">
    <p class="donation-invite__message text-body-1 text-medium-emphasis mb-0">
      {{ message }}
    </p>
    <ColumnButtons
      primary-text="Apoyar Escribonauta"
      primary-icon="mdi-heart"
      secondary-text="Ahora no"
      @primary-click="onSupport"
      @secondary-click="onDismiss"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import posthog from 'posthog-js'
import { useRouter } from 'vue-router'

import ColumnButtons from '@/components/baseComponents/ColumnButtons.vue'
import { DONATION_INVITE_MESSAGE } from '@/constants/donationPrompt'

export default defineComponent({
  name: 'DonationInviteContent',

  components: {
    ColumnButtons,
  },

  emits: ['support', 'dismiss'],

  setup(_, { emit }) {
    const router = useRouter()

    const onSupport = () => {
      if (import.meta.env.VITE_POSTHOG_PROJECT_TOKEN && import.meta.env.VITE_POSTHOG_HOST) {
        posthog.capture('donation_cta_clicked')
      }
      emit('support')
      router.push('/donations')
    }

    const onDismiss = () => {
      emit('dismiss')
    }

    return {
      message: DONATION_INVITE_MESSAGE,
      onSupport,
      onDismiss,
    }
  },
})
</script>
